var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{class:_vm.data.myclass,attrs:{"header":_vm.data.label,"shadow":_vm.data.shadow}},[_c('l-form-wraper',{attrs:{"myComponents":_vm.data.children}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }